export const IMAGE_LIMITS = {
  maxSize: 1048576,
  allowedTypes: ['jpg', 'jpeg', 'png']
}